//// Application Packages
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { WebChatContainer } from '@ibm-watson/assistant-web-chat-react'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'

//// Application Components
import IntroductionForm from '../../forms/registered-nursing-by-examination-forms/introduction-form'
import FunctionSuitabilityForm from '../../forms/registered-nursing-by-examination-forms/functional-suitability-form'
import GetStartedForm from '../../forms/registered-nursing-by-examination-forms/get-started-form'
import NameAndPersonalDetailsForm from '../../forms/generic-forms/name-and-personal-details-form'
import ContactInformationForm from '../../forms/generic-forms/contact-information-form'
import SpecialTestingAccommodationsForm from '../../forms/registered-nursing-by-examination-forms/special-testing-accommodations-form'
import ApplicantBackgroundForm from '../../forms/registered-nursing-by-examination-forms/applicant-background-form'
import OtherStateLicensesForm from '../../forms/generic-forms/other-state-licenses-form'
import AvailabilityForDisaster from '../../forms/generic-forms/availability-for-disaster-form'
import EducationHistoryForm from '../../forms/generic-forms/education-history-form'
import NonUsGraduatesForm from '../../forms/registered-nursing-by-examination-forms/non-us-graduates-form'
import ExaminationHistoryForm from '../../forms/registered-nursing-by-examination-forms/examination-history-form'
import HealthHistoryForm from '../../forms/generic-forms/health-history-form'
import DisciplineHistoryForm from '../../forms/generic-forms/discipline-history-form'
import CriminalHistory from '../../forms/generic-forms/criminal-history-form'
import SealedCriminalHistory from '../../forms/generic-forms/sealed-criminal-history-form'
import CriminalAndMedicaidMedicareFraudQuestionsForm from '../../forms/generic-forms/criminal-and-medicaid-medicare-fraud-questions-form'
import ElectronicFingerprintingForm from '../../forms/generic-forms/electronic-fingerprinting-form'
import FloridaCenterForNursingForm from '../../forms/registered-nursing-by-examination-forms/florida-center-for-nursing-form'
import NurseLicensureCompactForm from '../../forms/registered-nursing-by-examination-forms/nurse-licensure-compact-form'
import MilitaryFeeWaiverForm from '../../forms/generic-forms/military-fee-waiver-form'
import FileAttachmentsForm from '../../forms/registered-nursing-by-endorsement-forms/file-attachments-form'
import Attestation from '../../forms/generic-forms/attestation-form'
import SummarySubmissionForm from '../../forms/generic-forms/summary-submission-form'
import FormSubNavigationComponent from '../../components/navigation-components/form-sub-navigation-component'
import LoadingComponent from '../../components/simple-components/loading-component'

//// Carbon Components

//// Carbon Icons

//// Static Constants
const webChatOptions = {
    integrationID: `${process.env.REACT_APP_WATSON_ASSISTANT_INTEGRATION_ID}`,
    region: `${process.env.REACT_APP_WATSON_ASSISTANT_REGION}`,
    serviceInstanceID: `${process.env.REACT_APP_WATSON_ASSISTANT_REGION}`,
    clientVersion: `${process.env.REACT_APP_WATSON_ASSISTANT_CLIENT_VERSION}`,
    __ibm__: { useExactVersion: true },
    showCloseAndRestartButton: true,
    showLauncher: false,
    tourConfig: {
        hideMinimizeButton: true,
        hideChatButton: true,
    },
}

//////// Component
const RegisteredNursingByExaminationPage = () => {
    //////// Hooks

    //////// State
    const [instance, setInstance] = useState(null)

    //////// Slices
    const settingsData = useSelector(selectSettings)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const written_name = settingsData?.['form']?.['written_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Create Watson Assistant Instance
    const onBeforeRender = (instance, setInstance) => {
        setInstance(instance)
        instance?.updateAssistantInputFieldVisibility(false)
        instance.updateCSSVariables({
            'BASE-font-size-large': '16px',
        })
    }

    //////// Memoization

    //////// Effects/Side Effects
    // Reload Watson Assistant Journey on Reload
    useEffect(() => {
        if (instance?.tours) {
            instance.tours.endTour()
        }
        return () => {}
    }, [instance])

    //////////////// Render & Return
    if (digital_name === 'introduction') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        Registered Nurse by Examination - Introduction
                    </h2>
                    <IntroductionForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'function-suitability') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <FunctionSuitabilityForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'get-started') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <GetStartedForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'name-and-personal-details') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <NameAndPersonalDetailsForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'contact-information') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <ContactInformationForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'special-testing-accommodations') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <SpecialTestingAccommodationsForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'applicant-background') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <ApplicantBackgroundForm />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'other-state-licenses') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <OtherStateLicensesForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'availability-for-disaster') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <AvailabilityForDisaster />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'education-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <EducationHistoryForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'non-us-graduates') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <NonUsGraduatesForm />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'examination-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <ExaminationHistoryForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'health-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <HealthHistoryForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'discipline-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <DisciplineHistoryForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'summary-submission-form') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <SummarySubmissionForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'criminal-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <CriminalHistory instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'sealed-criminal-history') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <SealedCriminalHistory instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (
        digital_name === 'criminal-and-medicaid-medicare-fraud-questions'
    ) {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <CriminalAndMedicaidMedicareFraudQuestionsForm
                        instance={instance}
                    />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'electronic-fingerprinting') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <ElectronicFingerprintingForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'florida-center-for-nursing') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <FloridaCenterForNursingForm instance={instance} />
                    <WebChatContainer
                        config={webChatOptions}
                        onBeforeRender={(instance) =>
                            onBeforeRender(instance, setInstance)
                        }
                        hostURL={
                            process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL
                        }
                    />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'nurse-licensure-compact') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <NurseLicensureCompactForm />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'military-fee-waiver') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <MilitaryFeeWaiverForm />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else if (digital_name === 'file-attachments') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <FileAttachmentsForm instance={instance} />
                </div>
                <WebChatContainer
                    config={webChatOptions}
                    onBeforeRender={(instance) =>
                        onBeforeRender(instance, setInstance)
                    }
                    hostURL={process.env.REACT_APP_WATSON_ASSISTANT_HOST_URL}
                />
                <FormSubNavigationComponent />
            </>
        )
    } else if (digital_name === 'attestation') {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <Attestation />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    } else {
        return (
            <>
                <div className="form">
                    <h2 className="form-title">
                        {written_name ? written_name : ''}
                    </h2>
                    <LoadingComponent />
                    <FormSubNavigationComponent />
                </div>
            </>
        )
    }
}

export default RegisteredNursingByExaminationPage
